import React from 'react';
import FallbackState from './fallback-state';
import { useApi } from '../../context/api-context/use-api';
import DebugButton from '../dev-panel/debug-button';
import ConfigurationProvider from '../../context/configuration-context/configuration-provider';
import { isControllerInitialized } from '../../is-controller-initialized';
export default function withInvalidAppState(WrappedComponent, Fallback = FallbackState) {
    function WithInvalidAppState(props) {
        const { workerError, isSSR, baseParams, isInitialized } = useApi((state, _actions, _host, ctx) => ({
            workerError: ctx.wcWorkerError,
            isSSR: ctx.isSSR,
            baseParams: state.baseParams,
            isInitialized: isControllerInitialized(state),
        }));
        if (workerError && workerError.isSSR === true && isSSR !== false) {
            // worker error happened in SSR and this is SSR render we want to show nothing, because it might succeed on CSR
            return React.createElement(React.Fragment, null, "..."); // <Loader />;
        }
        if (workerError &&
            workerError.isSSR === false // worker error on CSR
        ) {
            if (workerError && workerError.wasWorkerErrorCaptured) {
                return (React.createElement(ConfigurationProvider, { config: props ?? {} },
                    baseParams.isDebug ? React.createElement(DebugButton, null) : null,
                    React.createElement(Fallback, { ...props, workerError: workerError })));
            }
            else {
                throw new Error(`Worker initialization failed: ${workerError ? workerError.error : 'There is no error, props were not set'}`); // this error will be caught by sentry error boundary
            }
        }
        if (!isInitialized) {
            return null;
        }
        return React.createElement(WrappedComponent, { ...props });
    }
    WithInvalidAppState.displayName = `withInvalidAppState(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return WithInvalidAppState;
}
//# sourceMappingURL=with-invalid-app-state-handler.js.map